import _ from 'underscore';
import { mapState } from 'vuex';

export default {
	name: 'user_preview',
	props: {
		user : Object
	},

	components : {
		
	},

	data : function(){

		return {}

	},

	created() {
		

	},

	destroyed() {
	},

	watch: {
		
	},
	computed: mapState({
		
		auth : state => state.auth,

		menu : function(){

			return this.core.user.extendByFeaturesMenu(_.filter([

				this.user.type == 4 || this.user.type == 0 ? {
					text: 'labels.changeUserType',
					icon: 'fas fa-user-tag',
					action: this.changeUserType,
		
					features : ['team']
				} : null,

				this.user.type == 0 ? {
					text: 'snippity.setTokenForUser',
					icon: 'fas fa-stroopwafel',
					action: this.setTokenForLessons,
		
					features : ['admin']
				} : null,

				this.user.type == 0 ? {
					text: 'snippity.giveDemo',
					icon: 'fa-solid fa-rss',
					action: this.demo,
		
					features : ['moderation']
				} : null,

				this.user.type == 4 ? {
					text: 'plans.partnerinfo',
					icon: 'fas fa-info-circle',
					action: this.partnerinfo,
		
					features : ['team']
				} : null
		
			], i => {
				return i
			}), true)

		},

		emailOrPhone : function(){
			if(this.user.phone.indexOf('***/') == -1) return this.user.phone
			if(this.user.email.indexOf('***/') == -1) return this.user.email

			return '-'
		}
	}),

	methods : {

		menuClick : function(){
			this.core.vueapi.listmenu(this.menu)
		},

		setTokenForLessons : function(){
			return this.core.promwrapper(this.core.api.lessons.admin.setToken(this.user.id)) 
		},

		demo : function(){
			return this.core.promwrapper(this.core.api.payments.demo(this.user.id, 365)) 
		},

		changeUserType : function(){

			var changeUserType = (type) => {
				return this.core.api.team.users.changeType({
					type,
					id : this.user.id
				})
			}

			var changeUserTypeToUser = () => {
				return changeUserType(0)
			}

			var changeUserTypeToBlogger = () => {
				return changeUserType(4)
			}

			var menu =  _.filter([this.user.type == 0 ? null : {
				text: 'labels.userTypeUser',
				icon: 'fas fa-user-tag',
				action: changeUserTypeToUser,
	
				features : ['team']
			}, this.user.type == 4 ? null : {
				text: 'labels.userTypeBlogger',
				icon: 'fas fa-user-tag',
				action: changeUserTypeToBlogger,
	
				features : ['team']
			}], (m) => {
				return m
			})

			setTimeout(() => {
				this.core.vueapi.listmenu(menu)
			}, 300)

		},

		partnerinfo : function(){
			setTimeout(() => {
				this.core.vueapi.partnerinfo({
					userid : this.user.id,
					mode : 'team'
				})
			}, 300)
		}
	},
}